import { render } from "./comunicaciones_form_old.vue?vue&type=template&id=41d3d27c"
import script from "./comunicaciones_form_old.vue?vue&type=script&lang=js"
export * from "./comunicaciones_form_old.vue?vue&type=script&lang=js"

import "./comunicaciones_form_old.vue?vue&type=style&index=0&id=41d3d27c&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__